const bestClinical = [
  {
    id: 136,
    title: 'A REAL-WORLD STUDY OF END TYROSINE KINASE INHIBITOR IN CHRONIC MYELOID LEUKAEMIA (ENTIC) IN MALAYSIA',
    presenting_author_name: 'SIEW LIAN CHONG',
  },
  {
    id: 201,
    title: "ANTIBODY RESPONSE POST-COVID-19 VACCINATION IN PATIENTS WITH CHRONIC MYELOID LEUKAEMIA WITH COMPARISON BETWEEN COMIRNATY AND CORONAVAC VACCINE",
    presenting_author_name: 'KUAN JEW WIN',
  },
  {
    id: 237,
    title: "AUTOLOGOUS CD19 CHIMERIC ANTIGEN RECEPTOR-T (CAR-T) THERAPY FOR RELAPSED/ REFRACTORY B-ACUTE LYMPHOBLASTIC LEUKAEMIA (B-ALL) PATIENTS- A PHASE II CLINICAL TRIAL IN MALAYSIA",
    presenting_author_name: 'S FADILAH ABDUL WAHID',
  },
  {
    id: 34,
    title: "CLINICAL OUTCOMES OF RELAPSED OR REFRACTORY DIFFUSE LARGE B CELL LYMPHOMA - A MULTICENTER REAL-WORLD STUDY IN MALAYSIA",
    presenting_author_name: 'S FADILAH ABDUL WAHID',
  },
  {
    id: 140,
    title: "HAPLOIDENTICAL BONE MARROW TRANSPLANT – A PERSONAL SERIES OF 21 PATIENTS FROM A PRIVATE MEDICAL CENTER",
    presenting_author_name: 'SOO-CHIN NG',
  },
  {
    id: 239,
    title: "HYPERLEUKOCYTOSIS IN PEDIATRIC ACUTE LEUKEMIAS AT CHIANG MAI UNIVERSITY HOSPITAL",
    presenting_author_name: 'RUNGROTE NATESIRINILKUL',
  },
  {
    id: 120,
    title: "IMMUNE RESPONSE OF CHRONIC MYELOID LEUKEMIA PATIENTS TOWARDS SARS-COV-2 VACCINATION",
    presenting_author_name: 'CHIN SUM CHEONG',
  },
  {
    id: 168,
    title: "IRON BURDEN AND ENDOCRINE COMPLICATIONS IN PATIENTS WITH TRANSFUSION-DEPENDENT THALASSAEMIA IN SARAWAK. A RETROSPECTIVE CROSS-SECTIONAL STUDY",
    presenting_author_name: 'CHOW LAI CHEE',
  },
  {
    id: 119,
    title: "LONG TERM TREATMENT OUTCOME OF MULTIPLE MYELOMA PATIENTS POST AUTOLOGOUS STEM CELL TRANSPLANTATION IN KLANG VALLEY HOSPITALS",
    presenting_author_name: 'CHIN SUM CHEONG',
  },
  {
    id: 161,
    title: "MULTIPLE MYELOMA IN BORNEO SARAWAK MALAYSIA: A DECADE OF EXPERIENCE IN A SINGLE CENTER",
    presenting_author_name: 'LEONG TZE SHIN',
  },
  {
    id: 178,
    title: "OUTCOME AND CLINICAL CHARACTERISTICS OF ADULT PATIENTS DIAGNOSED WITH ACUTE MYELOID LEUKAEMIA IN PENANG: A SINGLE CENTRE EXPERIENCE",
    presenting_author_name: 'CAROL GOH CHEW YUEN',
  },
  {
    id: 114,
    title: "OUTCOMES OF COVID-19 IN HAEMATOPOIETIC STEM CELL TRANSPLANT RECIPIENTS: A RETROSPECTIVE ANALYSIS IN A NATIONAL TRANSPLANT CENTRE IN MALAYSIA",
    presenting_author_name: 'ANDY TANG SING ONG',
  },
  {
    id: 190,
    title: "PLASMA CELL MYELOMA AND HYPER COAGULABILITY",
    presenting_author_name: 'TISHYA INDRAN',
  },
  {
    id: 220,
    title: "PREVALENCE OF INVASIVE FUNGAL INFECTION IN HAEMATOLOGY PATIENTS IN A TEACHING HOSPITAL",
    presenting_author_name: 'LIONG CHEE CHIAT',
  },
  {
    id: 216,
    title: "RISK FACTORS AND OUTCOME OF COVID-19 INFECTION IN HEMATOLOGICAL PATIENTS : A MULTICENTER RETROPECTIVE ANALYSIS IN MALAYSIA",
    presenting_author_name: 'SUI KEAT TAN',
  },
  {
    id: 159,
    title: "THE SARAWAK MYELOFIBROSIS EXPERIENCE (SAMY): DEMOGRAPHICS AND OUTCOME OF MYELOFIBROSIS PATIENTS IN SARAWAK, MALAYSIA",
    presenting_author_name: 'ANDY TANG SING ONG',
  },
  {
    id: 166,
    title: "THERAPEUTIC USE OF CONVALESCENCE PLASMA IN SEVERE ACUTE RESPIRATORY SYNDROME CORONAVIRUS 2 (SARS-COV-2) PATIENTS WITH HEMATOLOGICAL MALIGNANCIES IN HOSPITAL AMPANG",
    presenting_author_name: 'KULDEEP KAUR SARBAN SINGH',
  },
]

const bestLaboratory = [
  {
    id: 230,
    title: 'ASSOCIATION OF MANNOSE-BINDING LECTIN (MBL) GENE POLYMORPHISMS WITH IMMUNE THROMBOCYTOPENIA IN KELANTAN, MALAYSIA',
    presenting_author_name: 'MUHAMAD AIDIL ZAHIDIN',
  },
  {
    id: 89,
    title: "CHROMOSOMAL ABNORMALITIES IN CHRONIC LYMPHOCYTIC LEUKAEMIA PATIENTS TREATED IN HOSPITAL AMPANG, SELANGOR",
    presenting_author_name: 'JEROME TAN TSEN CHUEN',
  },
  {
    id: 167,
    title: "CLOT WAVE ANALYSIS (CWA) PARAMETERS IN PATIENT WITH PROLONGED IMMOBILIZATION",
    presenting_author_name: 'ROSMANIZA MUHAMAT YUSOFF',
  },
  {
    id: 151,
    title: "COMPARISON STUDY ON VIABILITY AND RECOVERY OF CD34+ HAEMATOPOIETIC STEM CELLS CRYOPRESERVED WITH 5% AND 10% DIMETHYLSULFOXIDE (DMSO)",
    presenting_author_name: 'DR NUR ZAINURA BINTI MOHAMAD',
  },
  {
    id: 155,
    title: "CYTOGENETIC FINDINGS AND ITS CORRELATION WITH OVERALL SURVIVAL (OS) AND EVENT FREE SURVIVAL (EFS) IN PATIENTS WITH AML",
    presenting_author_name: 'QHASMIRA BINTI ABU HAZIR',
  },
  {
    id: 188,
    title: "CYTOPEUTICS® HUMAN UMBILICAL CORD MESENCHYMAL STEM CELLS (HUC-MSCS):  CELL TRANSDUCIBILITY, IN VITRO INVESTIGATIONS AND BIODISTRIBUTION IN BALB/C MICE",
    presenting_author_name: 'MARINI BINTI MARZUKI',
  },
  {
    id: 235,
    title: "DELINEATION OF THE MOLECULAR BASIS OF BORDERLINE HAEMOGLOBIN A2 IN MALAYSIAN POPULATION",
    presenting_author_name: 'NORAFIZA BT MOHD YASIN',
  },
  {
    id: 80,
    title: "DOWNREGULATIN OF HSA-MIR-548D-3P AND OVEREXPRESSION OF HOXA9 IN DIFFUSE LARGE B-CELL LYMPHOMA PATIENTS AND THE RISK OF R-CHOP-CHEMOTHERAPY RESISTANCE/DISEASE PROGRESSION",
    presenting_author_name: 'TING CHOO YUEN',
  },
  {
    id: 112,
    title: "EXTENDED RBC PARAMETERS IN LATENT IRON DEFICIENCY AMONG BLOOD DONORS IN HOSPITAL USM",
    presenting_author_name: 'SIVANESAN SOCKALINGAM',
  },
  {
    id: 229,
    title: "FREQUENCY AND CLINICAL IMPLICATION OF ADDITIONAL CHROMOSOMAL ABNORMALITY IN ADULT PHILADELPHIA CHROMOSOME POSITIVE ACUTE LYMPHOBLASTIC LEUKEMIA",
    presenting_author_name: 'PHAN CHIN LEE',
  },
  {
    id: 138,
    title: "GENETICALLY ENGINEERED HUMAN UMBILICAL CORD-DERIVED MESENCHYMAL STEM CELLS EXPRESSING HUMAN INTERLEUKIN-12 INHIBIT LUNG ADENOCARCINOMA CELLS IN VITRO",
    presenting_author_name: 'GOH JIUNN JYE',
  },
  {
    id: 238,
    title: "HUMAN HB G-MAKASSAR IN MALAYSIA; IS IT COMMON?",
    presenting_author_name: 'EZALIA ESA',
  },
  {
    id: 137,
    title: "MOLECULAR INTERROGATION OF CHRONIC MYELOID LEUKAEMIA PATIENTS WHO FAILED SECOND GENERATION TYROSINE KINASE INHIBITOR USING NEXT GENERATION SEQUENCING",
    presenting_author_name: 'SIEW LIAN CHONG',
  },
  {
    id: 32,
    title: "MOLECULAR LANDSCAPE OF CASES WITH BORDERLINE HBA2 LEVELS IN HOSPITAL CANSELOR TUANKU MUHRIZ",
    presenting_author_name: 'LAILATUL HADZIYAH BINTI MOHD PAUZY',
  },
  {
    id: 185,
    title: "THE HAEMATOLOGICAL, HAEMOSTATIC AND INFLAMMATORY MARKERS IN EARLY SEPSIS BASED ON SOFA SCORE",
    presenting_author_name: 'FAIRUZ BINTI AMIL',
  },
]

const clinicalResearch = [
  {
    id: 121,
    title: "ADVERSE EVENTS FROM SARS-COV-2 VACCINATION AMONG PATIENTS WITH CHRONIC MYELOID LEUKEMIA IN MALAYSIA",
    presenting_author_name: 'CHIN SUM CHEONG',
  },
  {
    id: 116,
    title: "CLINICAL, HAEMATOLOGICAL AND CYTOGENETIC PROFILE OF ADULT MYELODYSPLASTIC SYNDROME IN TEACHING HOSPITAL, A SINGLE-CENTRE STUDY",
    presenting_author_name: 'CHEE WENG YAN SABRINA',
  },
  {
    id: 183,
    title: "COST OF TREATMENT FOR MYELOFIBROSIS PATIENTS IN MINISTRY OF HEALTH HOSPITALS IN SARAWAK",
    presenting_author_name: 'ANDY TANG SING ONG',
  },
  {
    id: 123,
    title: "EPIDEMIOLOGY AND CLINICAL PROFILES OF CUTANEOUS GRAFT VERSUS HOST DISEASE IN ALLOGENEIC PERIPHERAL BLOOD STEM CELL TRANSPLANTATION",
    presenting_author_name: 'Nor Saaidah Binti Kamal Rodin',
  },
  {
    id: 182,
    title: "FEASIBILITY AND SAFETY OF COLLECTION OF MONONUCLEAR CELLS FOR AUTOLOGOUS CHIMERIC ANTIGEN RECEPTOR-T (CAR-T) CELL THERAPY IN HAEMATOLOGIC MALIGNANCIES",
    presenting_author_name: 'DR. WINT WINT THU NYUNT',
  },
  {
    id: 225,
    title: "LONG-TERM CLINICAL OUTCOMES OF AUTOLOGOUS BONE MARROW MONONUCLEAR CELL IMPLANTATION IN PATIENTS WITH SEVERE THROMBOANGIITIS OBLITERANS",
    presenting_author_name: 'FARINA BINTI MOHAMAD YUSOFF',
  },
  {
    id: 231,
    title: "PERSISTENCE AND DECAY OF ANTI-SARS-COV2 IG G ANTIBODY RESPONSE POST BNT162B2 SARS-COV-2 ( PFIZER-BIONTECH, COMIRNATY) VACCINE IN PATIENT WITH VARIOUS HAEMATOLOGICAL CONDITIONS.",
    presenting_author_name: 'LOW PEI LING',
  },
  {
    id: 109,
    title: "PREVALENCE AND SPECIFICITY OF RBC ALLOIMMUNIZATION AMONG CHRONIC LIVER DISEASE PATIENT IN HOSPTAL UNIVERSITI SAINS MALAYSIA",
    presenting_author_name: 'SITI ZALEHA S ABDULLAH',
  },
  {
    id: 88,
    title: "REAL WORLD OUTCOME OF CHRONIC LYMPHOCYTIC LEUKAEMIA PATIENTS TREATED WITH VENETOCLAX IN HOSPITAL AMPANG, SELANGOR",
    presenting_author_name: 'JEROME TAN TSEN CHUEN',
  },
  {
    id: 143,
    title: "RED BLOOD CELL ALLOIMMUNIZATION AND AUTOIMMUNIZATION IN TRANSFUSION DEPENDENT THALASSEMIA: A SINGLE CENTRE RETROSPECTIVE REVIEW",
    presenting_author_name: 'KEE TAT LEE',
  },
  {
    id: 224,
    title: "RELATIONSHIP BETWEEN CELL NUMBER AND CLINICAL OUTCOMES OF AUTOLOGOUS BONE‐MARROW MONONUCLEAR CELL IMPLANTATION IN CRITICAL LIMB ISCHEMIA",
    presenting_author_name: 'FARINA BINTI MOHAMAD YUSOFF',
  },
  {
    id: 130,
    title: "THE DISTRIBUTION OF BCR-ABL1 FUSION TRANSCRIPTS AND THE INCIDENCE OF BLASTIC TRANSFORMATION AMONG CML PATIENTS IN KELANTAN",
    presenting_author_name: 'NABIHAH BINTI MOHD SHAKRI',
  },
  {
    id: 141,
    title: "TREATMENT FREE REMISSION (TFR) IN CHRONIC MYELOID LEUKEMIA (CML) -A MALAYSIAN PRIVATE CENTER EXPERIENCE.",
    presenting_author_name: 'SOO-CHIN NG',
  },
  {
    id: 234,
    title: "UTILISATION OF THERAPEUTIC PLASMA EXCHANGE IN TREATING TRANSPLANT-ASSOCIATED THROMBOTIC MICROANGIOPATHY: A SINGLE CENTRE RETROSPECTIVE CROSS-SECTIONAL COHORT STUDY",
    presenting_author_name: 'WONG YIH SEONG',
  },
  {
    id: 83,
    title: "VASOVAGAL REACTION AMONG BLOOD DONORS : PREVALENCE AND FACTOR ASSOCIATED",
    presenting_author_name: 'NUR NASUHA IBRAHIM',
  },
]

const laboratoryResearch = [
  {
    id: 228,
    title: "ASSOCIATION OF DENGUE WARNING SIGNS DURING FEBRILE PHASE WITH ROTATIONAL THROMBOELASTOMETRY, CORTISOL AND FERITIN",
    presenting_author_name: 'SYARIFAH SYAHIRAH SYED ABAS',
  },
  {
    id: 139,
    title: "CHARACTERIZATION OF RED BLOOD CELL PARAMETERS IN SOUTHEAST ASIAN OVALOCYTOSIS (SAO) AND NON-SOUTHEAST ASIAN OVALOCYTOSIS (NON-SAO) WITH OR WITHOUT THALASSAEMIA/HAEMOGLOBINOPATHIES",
    presenting_author_name: 'IZZATUL IZZANIS ABD HAMID',
  },
  {
    id: 184,
    title: "DOES OBESITY INCREASE RISK OF IRON DEFICIENCY? : A PRELIMINARY STUDY ON THE CORRELATION OF CENTRAL OBESITY, RED CELL INDICES AND IRON PARAMETERS",
    presenting_author_name: 'WAN ASMUNI WAN MOHD SAMAN',
  },
  {
    id: 31,
    title: "GENETIC VARIANTS OF GLUCOSE-6-PHOSPHATE DEHYDROGENASE (G6PD) DEFICIENCY IN SOUTHEAST ASIAN COUNTRIES AND FUTURE DIRECTIONS OF GENOMIC MEDICINE: A REVIEW",
    presenting_author_name: 'MOHAMED AFIQ HIDAYAT BIN ZAILANI',
  },
  // {
  //   id: 191,
  //   title: "IMMUNOPHENOTYPING IN THE DIAGNOSIS OF ACUTE UNDIFFERENTIATED LEUKEMIA AND MIXED PHENOTYPE ACUTE LEUKEMIA",
  //   presenting_author_name: 'SITI MAISARAH TERMITI',
  // },
  {
    id: 110,
    title: "KRÜPPEL-LIKE FACTOR 1 (KLF1) GENE MUTATION AMONG ALPHA THALASSAEMIA: RESULT OF A SINGLE REFERRAL CENTRE IN MALAYSIA",
    presenting_author_name: 'TAYE ZHI LING',
  },
  {
    id: 152,
    title: "MOLECULAR GENETICS OF ALPHA THALASSAEMIA IN SOUTH-EAST ASIA: A NARRATIVE REVIEW",
    presenting_author_name: 'SITI NURRAZAN BINTI ZULKIFLI',
  },
  {
    id: 176,
    title: "ROLE OF RUNX1 IN PLASMA CELL DIFFERENTIATION IN MULTIPLE MYELOMA PATIENTS",
    presenting_author_name: 'TANG TING FANG',
  },
  {
    id: 154,
    title: "SIGNIFICANCE OF ABERRANT EXPRESSION OF MYELOID MARKER IN CORRELATION OF CYTOGENETIC ABNORMALITY IN PATIENT WITH B-ACUTE LYMPHOBLASTIC LEUKAEMIA",
    presenting_author_name: 'MOHD FIKRI',
  },
  {
    id: 99,
    title: "THE PROFILE OF CMV-SPECIFIC T CELL IMMUNE RESPONSES IN ALLOGENEIC HAEMATOPOIETIC STEM CELL TRANSPLANTATION",
    presenting_author_name: 'NORFARAZIEDA HASSAN',
  },
  {
    id: 36,
    title: "VARYING PHENOTYPE PROFILE OF HAEMOGLOBIN ADANA INTERACTIONS",
    presenting_author_name: 'DR GOWRISANKARI NAVARETNAM',
  },
  {
    id: 107,
    title: "VERIFICATION OF THE REFERENCE INTERVAL OF WHITE BLOOD CELL PARAMETERS OF NEUT-GI AND NEUT-RI AMONG THE LOCAL POPULATION.",
    presenting_author_name: 'HO SOOK FONG',
  },
]

const caseClinical = [
  {
    id: 194,
    title: "A CASE REPORT OF ACQUIRED THROMBOTIC THROMBOCYTOPENIC PURPURA ASSOCIATED WITH COVID-19 INFECTION",
    presenting_author_name: 'LOW PEI LING',
  },
  {
    id: 202,
    title: "A CASE REPORT OF LEPTOMENINGEAL MYELOMATOSIS AND RAPID IMPROVEMENT WITH REGIMEN CONSISTING OF DARATUMUMAB, POMALIDOMIDE, VINCRISTINE, PROCARBAZINE, AND DEXAMETHASONE",
    presenting_author_name: 'KUAN JEW WIN',
  },
  {
    id: 197,
    title: "ACUTE PROMYELOCYTIC LEUKEMIA DURING PREGNANCY WITH DIFFERENTIATION SYNDROME",
    presenting_author_name: 'HO SOOK YEE',
  },
  {
    id: 233,
    title: "AN UNUSUAL CASE OF SPURIOUS HYPERLEUCOCYTOSIS",
    presenting_author_name: 'WU JIN TENG',
  },
  // {
  //   id: 134,
  //   title: "AUTOLOGOUS STEM CELL TRANSPLANTATION IN YOUNG ADULT WITH SOFT TISSUE AND BONE SARCOMA - SINGLE CENTRE EXPERIENCE",
  //   presenting_author_name: 'MOHD YAZID ZAMRI',
  // },
  {
    id: 133,
    title: "CASE REPORT: USE OF ARSENIC TRIOXIDE PLUS MANNITOL IN AN ACUTE PROMYELOCYTIC LEUKEMIA PATIENT WITH CENTRAL NERVOUS SYSTEM RELAPSE",
    presenting_author_name: 'TIONG CHIONG SENG',
  },
  {
    id: 122,
    title: "FACTOR VII DEFICIENCY: A RARE DISEASE WITH EVEN “RARER” TREATMENT",
    presenting_author_name: 'CHEW LEE PING',
  },
  {
    id: 95,
    title: "FORGOTTEN BUT NOT DISAPPEARED: ERYTHROPOIESIS STIMULATING AGENT INDUCED PURE RED CELL APLASIA",
    presenting_author_name: 'JEROME TAN TSEN CHUEN',
  },
  {
    id: 193,
    title: "HAEMOPHAGOCYTIC SYNDROME SECONDARY TO DISSEMINATED TUBERCULOSIS MASQUERADING AS DIFFERENTIATION SYNDROME IN A CASE OF APML POST ATRA-IDARUBICIN INDUCTION",
    presenting_author_name: 'BONG ZHAO SHENG',
  },
  {
    id: 160,
    title: "HEPATIC LYMPHOMA CAMOUFLAGE AS LIVER ABSCESS",
    presenting_author_name: 'GUANG YONG CHONG',
  },
  {
    id: 147,
    title: "HEPATOSPLENIC T-CELL LYMPHOMA : A RARE BUT AGGRESSIVE DISEASE",
    presenting_author_name: 'THAM YEA BING',
  },
  {
    id: 179,
    title: "HYPEREOSINOPHILIC SYNDROME WITH CRADIAC INVOLVEMENT: A CASE REPORT",
    presenting_author_name: 'JEEVAKANTHI RAJENDRAN',
  },
  {
    id: 211,
    title: "IT IS NOT ALWAYS THALASSEMIA - A CASE REPORT OF AUTOIMMUNE HAEMOLYTIC ANAEMIA IN A PATIENT WITH HAEMOGLOBIN LEPORE",
    presenting_author_name: 'TAN SWEE LOOI',
  },
  {
    id: 144,
    title: "LONGITUDINAL EXTENSIVE TRANVERSE MYELITIS ; A RARE PRESENTATION OF DIFFUSE LARGE B-CELL LYMPHOMA",
    presenting_author_name: 'DARSHYINI RAMANUJAM',
  },
  {
    id: 180,
    title: "METHOTREXATE ACUTE ENCEPHALOPATHY IN B LINEAGE ACUTE LYMPHOBLASTIC LEUKEMIA",
    presenting_author_name: 'YIP KAM HOO',
  },
  {
    id: 127,
    title: "PARANEOPLASTIC DEGENERATION IN HODGKIN LYMPHOMA",
    presenting_author_name: 'AZHREEN FUAD MOHAMAD AZUDIN',
  },
  {
    id: 214,
    title: "PARAPLEGIA IN ACUTE LYMPHOID LEUKEMIA: A CASE SERIES",
    presenting_author_name: 'WONG TIEN GEN',
  },
  {
    id: 203,
    title: "PITFALLS IN THE DIAGNOSIS OF A RELAPSED LYMPHOMA",
    presenting_author_name: 'LEE BEE SUN',
  },
  {
    id: 207,
    title: "SUCCESS SERIES OF A RARE LEUKEMIC VARIANT- BPDCN ( BLASTIC PLASMACYTOID DENDRITIC CELL NEOPLASM) - A SINGLE CENTRE EXPERIENCE",
    presenting_author_name: 'KHAITERI RAGHUNATHAN',
  },
  {
    id: 158,
    title: "SUCCESSFUL TREATMENT OF DISSEMINATED FUSARIUM INFECTION WITH ENDOPHTHALMITIS IN A PATIENT WITH ACUTE MYELOID LEUKEMIA",
    presenting_author_name: 'LEE ZHI YUAN',
  },
]

const caseLaboratory = [
  {
    id: 200,
    title: "A RARE CASE OF CO-INHERITANCE HAEMOGLOBIN CHARLIEU [A106(G13) LEU →PRO (A2)] WITH SOUTH EAST ASIAN OVALOCYTOSIS",
    presenting_author_name: 'NURUL HIDAYAH BINTI MUSA',
  },
  {
    id: 198,
    title: "A RARE CASE OF PARA-BOMBAY A ASSOCIATED WITH ANTI-H, ANTI-MIA AND POSSIBLE ANTI-M1 IN AN UNIVERSITY HOSPITAL",
    presenting_author_name: 'EVELYN TENG MEI YUONG',
  },
  {
    id: 219,
    title: "A RARE CASE OF T ACUTE LYMPHOBLASTIC LEUKAEMIA (T-ALL) WITH MINOR BCR::ABL1",
    presenting_author_name: 'SITI SHAHRUM MUHAMED SAID',
  },
  {
    id: 135,
    title: "CASE SERIES : THE MOLECULAR LANDSCAPE OF CHRONIC MYELOID LEUKAEMIA PATIENTS EXPERIENCING TREATMENT-FREE REMISSION FAILURE",
    presenting_author_name: 'SIEW LIAN CHONG',
  },
  {
    id: 156,
    title: "COLD AGGLUTININ (CA) - ASSOCIATED LYMPHOPROLIFERATIVE DISEASE (LPD),  A NEW DISEASE ENTITY",
    presenting_author_name: 'FATIN ADLIA BINTI ARIFIN',
  },
  {
    id: 93,
    title: "EBV POSITIVE DLBCL-A RARITY",
    presenting_author_name: 'HARI PRIYA RAGHVAN',
  },
  {
    id: 241,
    title: "FANCONI ANEMIA FROM A NOVEL MUTATION DETECTED BY WHOLE EXOME SEQUENCING: A CASE REPORT",
    presenting_author_name: 'RUNGROTE NATESIRINILKUL',
  },
  {
    id: 209,
    title: "LOW PULSE OXIMETER READINGS IN A GIRL WITH UNSTABLE HAEMOGLOBIN KÖLN [GTG→ ATG, VAL→ MET]: A CASE REPORT",
    presenting_author_name: 'RUZANAZ SYAFIRA RUZMAN AZLEE',
  },
  {
    id: 199,
    title: "MAST CELL LEUKEMIA",
    presenting_author_name: 'ANNIE SOUTI',
  },
  {
    id: 124,
    title: "PSEUDOTHROMBOCYTOSIS DUE TO RED CELL FRAGMENTATIONS IN A PREGNANT LADY WITH HBH DISEASE MASQUERADING AS MYELOPROLIFERATIVE NEOPLASMS: A CASE REPORT",
    presenting_author_name: 'TAN JIE EN',
  },
  {
    id: 173,
    title: "SYSTEMIC MASTOCYTOSIS IN A CASE OF ACUTE MYELOID LEUKEMIA ASSOCIATED WITH T(8;21)",
    presenting_author_name: 'FATIN ADLIA BINTI ARIFIN',
  },
  {
    id: 115,
    title: "UNUSUAL CASES OF HAEMOPHAGOCYTIC LYMPHOHISTIOCYTOSIS (HLH) COMPLICATING APLASTIC ANAEMIA (AA), A POSSIBLE ASSOCIATION?",
    presenting_author_name: 'CHEE WENG YAN SABRINA',
  },
]

export { bestClinical, bestLaboratory, clinicalResearch, laboratoryResearch, caseClinical, caseLaboratory }